import { extendBannerStylesheet } from "@devowl-wp/web-cookie-banner";
import { useStylesheet } from "../../contexts";
function useBannerStylesheet() {
  return useStylesheet().extend(...extendBannerStylesheet);
}
export { useBannerStylesheet };